module.exports = __webpack_public_path__ + "static/media/shapes_04.e959f305.svg";